import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Form, Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import * as homepageSlice from "../../../../redux/slices/homepageSlice";
import * as locationSlice from "../../../../redux/slices/locationSlice";
import * as faqChatSlice from "../../../../redux/slices/faqChatSlice";
import { toast } from "react-toastify";
import { imageBaseUrl } from "../../../../helper";
import DataTable from "react-data-table-component"; // Import DataTable
import DeleteModal from "../../components/DeleteModal";
import { Trash } from "feather-icons-react/build/IconComponents";
import { NotePencil } from "@phosphor-icons/react";

const FaqChatBot = () => {
  const [showEditTempleModal, setShowEditTempleModal] = useState(false);
  const [form, setForm] = useState({});
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [deletableId, setDeletableId] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [locationId, setLocationId] = useState();
  const { locationData } = useSelector((state) => state.locationSlice);
  const { allPickupPoints, allTopics, loading } = useSelector(
    (state) => state.faqChatSlice
  );
console.log(allTopics,"allTopics")
  // Modal state for adding temple
  const [showAddTempleModal, setShowAddTempleModal] = useState(false);
  const [sortNumber, setSortNumber] = useState();
  const [selectedImage, setSelectedImage] = useState();
  const [previewImage, setPreviewImage] = useState();

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
    dispatch(faqChatSlice.getTopics());
  }, [dispatch]);

  useEffect(() => {
    if (!showEditTempleModal) {
      setSortNumber(0);
    }
  }, [showEditTempleModal]);

  // Handle delete
  const handleDelete = async(locationId) => {
    await dispatch(faqChatSlice.destroyTopic(locationId));
    dispatch(faqChatSlice.getTopics());
    setDeleteModal(false);
  };

  // DataTable columns definition
  const columns = [
    {
      name: "#",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "60px",
    },
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
    },
    {
      name: "Topic",
      selector: (row) => row?.topic || "-",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <div className="d-flex">
          <div className="delete">
            <Trash onClick={() => handleDelete(row.id)} size={19} />
          </div>
          <div
            className="edit ml-1"
            onClick={(e) => {
              handleOnEditClick(row.id);
              setShowAddTempleModal(true);
              setIsEdit(true);
            }}
          >
            <NotePencil size={18} />
          </div>
        </div>
      ),
    },
  ];

  const handleOnEditClick = (id) => {
    const data = allTopics?.find((h) => h?.id === id);
    setLocationId(data?.id);
    setForm({
      ...form,
      topic:data?.topic
    });
  };

  const handleUpdate = async (event) => {
    event.preventDefault();
    if(!form?.topic){
      toast("Enter topic name please"); return ;
    }
    await dispatch(faqChatSlice.updateTopic(locationId, form, setForm));
    setSelectedImage(null);
    setPreviewImage(null);
    setShowAddTempleModal(false);
    dispatch(faqChatSlice.getTopics());
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if(!form?.topic){
      toast("Enter topic name please"); return ;
    }
    await dispatch(faqChatSlice.storeTopic(form, setForm));
    setShowAddTempleModal(false);
    dispatch(faqChatSlice.getTopics());
  };

  return (
    <>
      <h5 className="mb-4">FAQ Topic</h5>

      <Row className="mt-4">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <Button
            style={{
              backgroundColor: "#e8783d",
              border: "none",
              marginBottom: "1vh",
            }}
            onClick={() => {
              setIsEdit(false);
              setForm({});
              setShowAddTempleModal(true);
            }}
          >
            Add
          </Button>
        </Col>
      </Row>

      {loading ? (
        <div className="w-100 d-flex">
          <div
            className="spinner-border text-primary mx-auto"
            role="status"
          ></div>
        </div>
      ) : (
        <DataTable
          columns={columns}
          data={(allTopics?.length && allTopics) || []}
          pagination
          highlightOnHover
          pointerOnHover
        />
      )}

      {/* Add Banner Modal */}
      <Modal
        show={showAddTempleModal}
        onHide={() => setShowAddTempleModal(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
        }}
        dialogClassName="modal-90w" // Optional: To make the modal wider
      >
        <Modal.Header closeButton>
          <Modal.Title>{isEdit ? "Update" : "Add"} Topic</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formSortNumber" className="mb-3">
              <Form.Label>Enter Topic</Form.Label>
              <Form.Control
                type="text"
                value={form?.topic}
                onChange={(e) =>
                  setForm({ ...form, topic: e.target.value })
                }
                placeholder="Enter Topic Here"
                required // Optional: If you want to make this field mandatory
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowAddTempleModal(false)}
          >
            Close
          </Button>
          {isEdit ? (
            <Button variant="primary" type="submit" onClick={handleUpdate}>
              Update
            </Button>
          ) : (
            <Button variant="primary" type="submit" onClick={handleSubmit}>
              Save
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FaqChatBot;
